<template>
  <el-form ref="form" :model="form" label-width="140px" class="elForm">
    <el-form-item label="排名：">
      <el-input placeholder="请输入内容" v-model="form.input" style="width: 400px;"></el-input>
    </el-form-item>
    <el-form-item label="公告标题：" required="true">
      <el-input placeholder="请输入内容" v-model="form.input2" style="width: 700px"></el-input>
    </el-form-item>
    <el-form-item label="公告分类：" required="true">
      <el-select size="small" v-model="form.role_type" clearable style="width: 700px">
        <el-option label="全部" value=""></el-option>
        <el-option v-for="item in role_type" :key="item.val" :label="item.label" :value="item.val"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="副标题：">
      <el-input placeholder="请输入内容" v-model="input2" style="width: 700px"></el-input>
    </el-form-item>
    <el-form-item label="公告时间：" required="true">
      <el-input placeholder="请输入内容" v-model="input2" style="width: 700px"></el-input>
    </el-form-item>
    <el-form-item label="是否显示：" required="true">
      <el-switch v-model="value" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
    </el-form-item>
    <el-form-item label="公告详情：" required="true">
      <RichText :richTxt="form.goods_details" @soninfo="val => (form.goods_details = val)"></RichText>
    </el-form-item>
    <el-form-item class="centerBtn">
      <el-button type="primary" @click="onSubmit">添加</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import RichText from '@/components/richText';
export default {
  components: {
    RichText,
  },
  data() {
    return {
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
        // 图片
        url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
        srcList: [
          'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
          'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg'
        ]
      },
    };
  },
  methods: {
    onSubmit() {
      console.log('submit!');
    },
  },
};
</script>

<style lang="less" scoped>
.elForm {
  background-color: #fff;
  padding: 30px;
}

.centerBtn {
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>
